import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useStartWindowSession = () => {
    const send = useGenericSend();

    return useCallback(async (
        request: Partial<Types.IStartWindowSessionRequestData> & { windowSessionId: string },
        options?: { signal?: AbortSignal }
    ): Promise<Types.IStartWindowSessionResponseData> => {
            const {
                windowSessionId,
                subscriptionTags,
                subscriptionActionTypes,
                subscriptionBalanceTypes,
                subscriptionRequestedPlayerData,
                ...rest
            } = request;
            const { data } = await send<Types.IStartWindowSessionRequestData, Types.IStartWindowSessionResponseData>({
                ID: 31127,
                responses: [31128, 31129],
                description: 'Start Window Session',
                name: 'Bonus',
                windowSessionId,
                subscriptionTags,
                subscriptionBalanceTypes,
                subscriptionRequestedPlayerData,
                ...subscriptionActionTypes?.length && { subscriptionActionTypes },
                ...rest
            }, options);

            return data;
        }, [
            send
        ]);
};
